<template><CookieSection /></template>

<script>
import CookieSection from "@/components/CookieSection.vue";

export default {
  inheritAttrs: false,
  components: {
    CookieSection,
  },
};
</script>

<style lang="scss"></style>
